<angular-slickgrid
  [gridId]="uniqueGridId()"
  [columns]="columnDefinitions()"
  [options]="gridOptions"
  [dataset]="dataset()"
  (onAngularGridCreated)="ready($event)"
  (onGridStateChanged)="gridStateChanged($event.detail)"
  (onBeforeEditCell)="handleBeforeEditCell($event.detail)"
  (onCellChange)="handleCellChange($event.detail)"
  (onBeforeCellEditorDestroy)="handleBeforeCellEditorDestroy($event.detail)"
  (onValidationError)="handleValidationError($event.detail)"
  (onDblClick)="handleOnDblClick($event.detail)"
  (onHeaderMenuCommand)="handleHeaderMenuCommand($event.detail)"
  (onColumnsResizeDblClick)="handleColumnsResizeDblClick($event.detail)"
  (onColumnsChanged)="handleColumnsChanged($event.detail)"
  (onColumnsReordered)="handleColumnsReordered($event.detail)"
>
</angular-slickgrid>

<abp-modal
  [visible]="hasErrors"
  (visibleChange)="onErrorModalVisibleChange($event)"
  (closed)="onErrorModalVisibleChange(false)"
  [options]="errorModalOptions"
>
  <ng-template #abpHeader>
    <div class="modal-header-title">
      <h3>{{errorTitle}}</h3>
    </div>
  </ng-template>

  <ng-template #abpBody>
    <p>{{errorMessage}}</p>
  </ng-template>

<ng-template #abpFooter>
  <zn-button
    type="secondary"
    (clicked)="onErrorModalVisibleChange(false)"
    [label]="getCloseLabel()"
  ></zn-button>
  </ng-template>
</abp-modal>
